<!-- 首页 -->
<template>
  <div class="frame">
    <div id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
          <a :href="item.hrefUrl || 'javascript:;'">
            <img :src="URL + item.sourceUrl" class="post" :alt="item.name" />
          </a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="container">
      <div class="box">
        <div
          :class="{
            block: true,
            'new-center': true,
            full: newSwiperList.length == 0,
          }"
        >
          <div class="title-box">
            <div class="title">公示公告</div>
            <router-link to="/notice" class="more">更多</router-link>
          </div>
          <div class="content">
            <div class="list">
              <div
                class="item"
                v-for="item in newsList['公示公告']"
                :key="item.id"
                @click="navToDetail(item)"
              >
                <i class="el-icon-d-arrow-right"></i>
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="block brand" v-show="newSwiperList.length != 0">
          <div id="swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="item in newSwiperList"
                :key="item.id"
                @click="navToDetail(item)"
              >
                <div class="in">
                  <img :src="URL + item.newsImageUrl" class="post" />
                  <div class="title">{{ item.title }}</div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="block public">
          <div class="title-box">
            <div class="title">行业动态</div>
            <router-link to="/industry" class="more">更多</router-link>
          </div>
          <div class="content">
            <div class="news">
              <router-link
                class="new"
                :to="'/newDetail/industry/' + item.id"
                v-for="item in newsList['行业动态']"
                :key="item.id"
              >
                <div class="title dot">{{ item.title }}</div>
                <div class="time">
                  {{ (item.publishTime || item.createTime).split(" ")[0] }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="block public">
          <div class="title-box">
            <div class="title">政策法规</div>
            <router-link to="/policy" class="more">更多</router-link>
          </div>
          <div class="content">
            <div class="news">
              <router-link
                class="new"
                :to="'/newDetail/policy/' + item.id"
                v-for="item in newsList['政策法规']"
                :key="item.id"
              >
                <div class="title dot">{{ item.title }}</div>
                <div class="time">
                  {{ (item.publishTime || item.createTime).split(" ")[0] }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <img class="slogan" src="@/assets/kv.png" alt="slogan" />
      <div class="box">
        <div class="block notice full">
          <div class="title-box">
            <div class="title">行业标准</div>
            <router-link to="/standard" class="more">更多</router-link>
          </div>
          <div class="content">
            <div class="list">
              <router-link
                class="item"
                :to="'/newDetail/standard/' + item.id"
                v-for="item in newsList['行业标准']"
                :key="item.id"
              >
                <div class="title">{{ item.title }}</div>
                <div class="time">
                  {{ (item.publishTime || item.createTime).split(" ")[0] }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="block public full">
          <div class="title-box">
            <div class="title">培训中心</div>
            <router-link to="/train" class="more">更多</router-link>
          </div>
          <div class="content">
            <div class="trains" id="train">
              <div class="swiper-wrapper">
                <div
                  class="post swiper-slide"
                  v-for="item in trainTypes"
                  :key="item.id"
                  @click="navToTrainList(item)"
                >
                  <img :src="URL + item.imageUrl" />
                  <div class="title">{{ item.typeName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="block public full">
          <div class="title-box">
            <div class="title">友情链接</div>
          </div>
          <div class="content">
            <Scroll :list="friendLink" height="40px">
              <div class="friendlinks" v-for="item in 2" :key="item">
                <a
                  :href="item.hrefUrl"
                  target="_blank"
                  class="friendlink"
                  v-for="item in friendLink"
                  :key="item.id"
                  >{{ item.name }}</a
                >
              </div>
            </Scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "../util/config";
import Scroll from "@/components/scroll";
export default {
  components: { Scroll },
  data() {
    return {
      URL,
      bannerList: [],
      newSwiperList: [], // 公示公告中有缩略图的新闻
      types: {
        行业动态: 5,
        政策法规: 5,
        公示公告: 10,
        行业标准: 8,
      }, // 需要查询的所有新闻及pageSize
      newsList: {
        行业动态: [],
        政策法规: [],
        公示公告: [],
        行业标准: [],
      }, // 所有新闻列表
      trainTypes: [],
      trainList: [],
      friendLink: [],
    };
  },
  created() {},
  mounted() {
    this.getLink();
    this.getBanner();
    this.getAllNews();
    this.getTrainDic();
    // this.getTrain();
  },
  methods: {
    getLink() {
      this.$api.getFriendLink().then((res) => {
        this.friendLink = res.data;
      });
    },
    // 获取培训分类
    async getTrainDic() {
      let res = await this.$api.getTrainDic();
      this.trainTypes = res.data;
      setTimeout(() => {
        this.initTrainSwiper();
      }, 100);
    },
    async getBanner() {
      let res = await this.$api.getBannerList();
      this.bannerList = res.data;

      setTimeout(() => {
        new window.Swiper("#banner", {
          loop: true,
          autoplay: true,
          pagination: {
            el: "#banner .swiper-pagination",
            bulletClass: "banner-bullet",
            bulletActiveClass: "banner-bullet-active",
          },
        });
      }, 10);
    },
    async getAllNews() {
      for (const key in this.types) {
        const params = {
          pageIndex: 1,
          pageSize: this.types[key],
          typeName: key,
        };
        let res = await this.$api.getNewsList(params);
        this.newsList[key] = res.data.list;
      }
      this.newSwiperList = this.newsList["公示公告"].filter(
        (ele) => ele.newsImageUrl
      );
      setTimeout(() => {
        this.initSwiper();
      }, 10);
    },
    getTrain() {
      this.$api.getTrainList({ pageIndex: 1, pageSize: 10 }).then((res) => {
        this.trainList = res.data.list;
      });
    },
    initSwiper() {
      new window.Swiper("#swiper", {
        loop: true,
        autoplay: true,
        pagination: {
          el: "#swiper .swiper-pagination",
          bulletClass: "banner-bullet",
          bulletActiveClass: "banner-bullet-active",
        },
      });
    },
    initTrainSwiper() {
      new window.Swiper("#train", {
        slidesPerView: 4,
        autoplay: {
          delay: 3000,
        },
      });
    },
    // 前往新闻详情
    navToDetail(item) {
      this.$router.push("/newDetail/notice/" + item.id);
    },
    navTo(path) {
      this.$router.push(path);
    },
    navToTrainList(item) {
      this.$router.push("/train?type=" + item.typeName);
    },
  },
};
</script>

<style lang="scss" scoped>
.dot {
  position: relative;

  &::after {
    content: "";
    display: block;
    width: 3px;
    height: 3px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: $theme;
  }
}

.frame {
  width: 100%;
  box-sizing: border-box;

  #banner {
    position: relative;
    overflow: hidden;

    ::v-deep {
      .banner-bullet {
        width: 20px;
        height: 3px;
        display: inline-block;
        background-color: #f5f5f5;
        margin: 0 5px;
        border-radius: 10px;
      }
      .banner-bullet-active {
        background-color: $theme;
      }
    }
    .swiper-slide {
      width: 100%;

      .post {
        width: 100%;
        height: 450px;
        object-fit: cover;
        display: block;
      }
      .title {
        font-size: 15px;
        padding: 10px 10px 20px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;

    .box {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;

      &:last-child {
        margin-bottom: 20px;
      }

      .block {
        background-color: #fff;
        box-sizing: border-box;

        .title-box {
          height: 31px;
          line-height: 31px;
          padding-right: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: url(@/assets/bg_tit.png) bottom repeat-x;

          .title {
            height: 100%;
            padding: 0 20px;
            background-color: $theme;
            font-size: 18px;
            color: #fff;
            position: relative;

            &::after {
              content: "";
              display: block;
              position: absolute;
              right: -24px;
              top: 0;
              border-width: 16px 12px;
              border-style: solid;
              border-color: transparent transparent transparent $theme;
            }
          }
          .more {
            font-size: 14px;

            &:hover {
              cursor: pointer;
              text-decoration: underline;
              color: $theme;
            }
          }
        }

        #swiper {
          width: 590px;
          height: 300px;
          position: relative;
          overflow: hidden;

          ::v-deep {
            .banner-bullet {
              width: 20px;
              height: 3px;
              display: inline-block;
              background-color: #f5f5f5;
              margin: 0 5px;
              border-radius: 10px;
            }
            .banner-bullet-active {
              background-color: $theme;
            }
            .swiper-pagination-horizontal {
              bottom: 40px;
            }
          }
          .swiper-slide {
            width: 100%;
            position: relative;
            cursor: pointer;
            overflow: hidden;

            &:hover {
              .post {
                transform: scale(1.1);
              }
            }

            .in {
              width: 100%;
              max-height: 100%;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              overflow: hidden;
            }

            .post {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
              transition: 0.3s;
            }
            .title {
              width: 100%;
              font-size: 13px;
              padding: 8px 10px;
              color: #fff;
              background-color: rgba($color: #000000, $alpha: 0.5);
              box-sizing: border-box;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }
      }
      .new-center {
        width: 590px;
        border-left: 0;

        .content {
          .list {
            .item {
              line-height: 40px;
              padding-left: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              border-bottom: 1px dotted #d9d9d9;
              font-size: 14px;
              cursor: pointer;
              transition: 0.3s;

              &:last-child {
                border-bottom: 0;
              }
              &:hover {
                transform: translateX(-5px);
                color: $theme;
              }
              i {
                color: #f60;
                font-size: 13px;
                margin-right: 2px;
              }
            }
          }
        }
      }
      .notice {
        width: 49%;

        .content {
          max-height: 300px;
          overflow: auto;

          .list {
            .item {
              font-size: 14px;
              display: block;
              border-bottom: 1px dashed #d9d9d9;
              margin-bottom: 10px;
              padding: 10px 0 10px 10px;
              position: relative;

              &:hover {
                .title {
                  color: $theme;
                }
              }

              &::after {
                content: "";
                width: 3px;
                height: 3px;
                background-color: $theme;
                position: absolute;
                left: 0;
                top: 18px;
              }

              .time {
                color: #999;
                font-size: 13px;
                margin-top: 5px;
              }
            }
          }
        }
      }
      .brand {
        display: flex;
        align-items: center;
      }
      .public {
        width: 49%;
        box-sizing: border-box;

        .content {
          padding-top: 10px;

          .news {
            .new {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px dotted #d9d9d9;
              line-height: 40px;

              &:hover {
                .title {
                  transform: translateX(-5px);
                  color: $theme;
                }
              }

              &:last-child {
                border-bottom: 0;
              }

              .title {
                font-size: 14px;
                padding-left: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                transition: 0.5s;
              }
              .time {
                color: #999;
                font-size: 13px;
                margin-left: 10px;
                flex-shrink: 0;
              }
            }
          }

          .trains {
            overflow: hidden;
            position: relative;
            margin-bottom: 1%;

            .post {
              width: 25%;
              height: 100%;
              flex-shrink: 0;
              padding: 0 5px;
              box-sizing: border-box;
              overflow: hidden;
              cursor: pointer;

              &:hover {
                .title {
                  text-decoration: underline;
                }
                img {
                  transform: scale(1.1);
                }
              }

              img {
                width: 98%;
                height: 150px;
                object-fit: cover;
                transition: 0.4s;
              }
              .title {
                font-size: 14px;
                text-align: center;
                margin-top: 5px;
              }
            }
          }

          #slider {
            position: relative;
            overflow: hidden;
            padding-bottom: 15px;

            ::v-deep {
              .banner-bullet {
                width: 20px;
                height: 3px;
                display: inline-block;
                background-color: #f5f5f5;
                margin: 0 5px;
                border-radius: 10px;
              }
              .banner-bullet-active {
                background-color: $theme;
              }
              .swiper-horizontal > .swiper-pagination-bullets,
              .swiper-pagination-bullets.swiper-pagination-horizontal {
                bottom: 0;
              }
            }

            .swiper-slide {
              font-size: 14px;
              max-width: 30%;

              &:hover {
                cursor: pointer;

                .title {
                  color: $theme;
                }
              }

              .post {
                width: 100%;
                height: 76px;
                overflow: cover;
                display: block;
              }
              .title {
                padding: 8px 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                background-color: #f5f5f5;
              }
            }
          }
          .friendlinks {
            height: 60px;
            display: flex;
            // flex-direction: column;
            // flex-wrap: wrap;
            // width: 100%;
            // overflow: auto;
            // padding-bottom: 10px;

            .friendlink {
              flex-shrink: 0;
              margin-right: 30px;
              color: #000;
              cursor: pointer;

              &:hover {
                color: $theme;
              }
              // &:nth-child(2n) {
              //   margin-top: 5px;
              // }
            }
          }
        }
      }
      .menus {
        width: auto;
        margin-left: 10px;
        padding: 0;
        flex-grow: 1;

        .content {
          height: 100%;
          display: flex;
          flex-direction: column;

          .menu {
            height: 50%;
            padding: 10px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: $theme;
            font-size: 20px;
            cursor: pointer;
            background-image: linear-gradient(to bottom, #fff, #f4f6fc);

            & + .menu {
              border-top: 1px solid #e8e8e8;
            }

            &:active {
              transform: scale(0.9);
            }

            .icon {
              width: auto;
              height: 50px;
              margin-bottom: 10px;
            }
          }
        }
      }
      .other {
        width: 393px;
      }
      .full {
        width: 100%;
      }
    }

    .slogan {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    padding: 50px 0 10px;
    min-height: calc(100vh - 30px);

    #banner .swiper-slide .post {
      height: 200px;
    }
  }
  .frame .container {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;

    .box {
      flex-direction: column;
      padding: 10px 0;

      .block {
        width: 100%;

        & + .block {
          margin-top: 10px;
        }

        #swiper {
          width: 100%;
        }
      }
      .menus,
      .notice,
      .public + .public {
        margin-left: 0;
        margin-top: 10px;
      }
      .public .content {
        #slider {
          .swiper-slide {
            max-width: 100%;
          }
        }
        .friendlinks {
          font-size: 14px;

          .friendlink {
            margin-bottom: 3px;
          }
        }
      }
      .brand {
        padding: 0;

        #swiper .swiper-slide .post {
          height: 228px;
        }
      }
      .new-center {
        margin-top: 10px;
      }
      .menus {
        .content {
          flex-direction: row;

          .menu {
            width: 50%;
            height: 100%;
            padding: 20px 0;

            & + .menu {
              border-top: 0;
              border-left: 1px solid #e8e8e8;
            }
            .icon {
              height: 40px;
            }
            .label {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
